<div class="card card-dark mb-0">
    <div class="card-header" *ngIf="showHeader">
        <h2 class="card-title">{{label}}</h2>
        <div class="card-tools">
            <div class="input-group input-group-sm" style="width: 200px;">
                <input type="text" id="inputSearchHoy" name="inputSearchHoy" class="form-control" placeholder="Buscar"
                    (keyup)="updateFilter($event)">
                <div class="input-group-append">
                    <span class="input-group-text bg-info"><i class="fas fa-search"></i></span>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body p-0">
        <div class="table-responsive">
            <table class="table table-hover m-0">
                <thead>
                    <tr>
                        <th style="max-width: 110px;min-width: 110px;width: 110px;" *ngIf="mini" class="text-center">
                            Info</th>
                        <th style="max-width: 60px;min-width: 60px;width: 60px;" *ngIf="!mini"
                            class="text-center cursor-pointer" (click)="sortData('saldo')">$ <i
                                [class]="getIcon('saldo')" aria-hidden="true"></i></th>
                        <th style="max-width: 120px;min-width: 120px;width: 120px;" class="cursor-pointer"
                            (click)="sortData('id_pedido')">Pedido <i [class]="getIcon('id_pedido')"
                                aria-hidden="true"></i></th>
                        <th style="max-width: 110px;min-width: 110px;width: 110px;" class="cursor-pointer"
                            (click)="sortData('fecha_ingreso')">Ingreso <i [class]="getIcon('fecha_ingreso')"
                                aria-hidden="true"></i></th>
                        <th style="max-width: 110px;min-width: 110px;width: 110px;" class="cursor-pointer"
                            (click)="sortData('fecha_termino')">Termino <i [class]="getIcon('fecha_termino')"
                                aria-hidden="true"></i></th>
                        <th style="max-width: 130px;min-width: 130px;width: 130px;" *ngIf="!mini" class="cursor-pointer"
                            (click)="sortData('total_venta')">Total Venta <i [class]="getIcon('total_venta')"
                                aria-hidden="true"></i></th>
                        <th style="max-width: 140px;min-width: 140px;width: 140px;" *ngIf="!mini" class="cursor-pointer"
                            (click)="sortData('estado.nombre_estado')">Estado <i
                                [class]="getIcon('estado.nombre_estado')" aria-hidden="true"></i></th>
                        <th style="min-width: 200px;" *ngIf="showCliente" class="cursor-pointer"
                            (click)="sortData('cliente.nombre_completo')">Cliente <i
                                [class]="getIcon('cliente.nombre_completo')" aria-hidden="true"></i></th>
                        <th style="max-width: 120px;min-width: 120px;width: 120px;" *ngIf="!mini" class="text-center">
                            Infografía</th>
                        <th style="max-width: 120px;min-width: 120px;width: 120px;"></th>
                    </tr>
                </thead>
                <div class="progress-linear" *ngIf="isLoading">
                    <div class="container">
                        <div class="bar"></div>
                    </div>
                </div>
                <tbody *ngIf="!isLoading">
                    <tr *ngFor="let row of rows | pagination: {itemsPerPage: itemsPerPage, currentPage:page}">
                        <td style="max-width: 110px;min-width: 110px;width: 110px;" *ngIf="mini" class="text-center">
                            <app-popover [classIcon]="'fas fa-tshirt ml-1'" [colorIcon]="'text-primary'"
                                *ngIf="row.productos" [message]="row.productos"></app-popover>
                            <app-popover [classIcon]="'fas fa-comment-dots ml-1'" [colorIcon]="'text-orange'"
                                [message]="row.observacion != '' ? row.observacion : 'S/C'"></app-popover>
                            <app-popover
                                [classIcon]="row.tiene_despacho > 0 ? 'fas fa-shipping-fast ml-1' : 'fas fa-store-alt ml-1'"
                                [colorIcon]="'text-lightblue'"
                                [message]="row.tiene_despacho > 0 ? '<b>DESPACHO</b>' : '<b>LOCAL</b>'"></app-popover>
                            <app-popover [classIcon]="'fas fa-info-circle ml-1'" [colorIcon]="'text-warning'"
                                *ngIf="row.fecha_termino == nextDay && row.id_estado != 5"
                                [message]="'<em>Entrega para</em> <b>MAÑANA</b>'"></app-popover>
                            <app-popover [classIcon]="'fas fa-info-circle ml-1'" [colorIcon]="'text-danger'"
                                *ngIf="row.fecha_termino == nowDay && row.id_estado != 5"
                                [message]="'<em>Entrega para</em> <b>HOY</b>'"></app-popover>
                            <app-popover [classIcon]="'fas fa-calendar-check ml-1'" [colorIcon]="'text-success'"
                                *ngIf="row.fecha_entrega_efectiva != null && row.id_estado == 5"
                                [message]="'<em>Entrega efectiva</em> <b>' + this.FechaFunc.DateTimeFormated(row.fecha_entrega_efectiva) + '</b>'"></app-popover>
                        </td>
                        <td style="max-width: 60px;min-width: 60px;width: 60px;" *ngIf="!mini" class="text-center">
                            <app-popover [classIcon]="'fas fa-comment-dollar ml-1'"
                                [colorIcon]="row.saldo == 0 ? 'text-success' : row.saldo == row.total_venta ? 'text-danger' : 'text-warning'"
                                [message]="row.saldo == 0 ? 'Pagado' : (row.saldo == row.total_venta ? 'No pagado' : 'Pago parcial') + ' (Saldo: ' + this.FechaFunc.currencyPeso(row.saldo) + ')'"></app-popover>
                        </td>
                        <td style="max-width: 120px;min-width: 120px;width: 120px;">
                            <span>{{row.numero_pedido_format || row.id_pedido_format}}</span>
                        </td>
                        <td style="max-width: 110px;min-width: 110px;width: 110px;">
                            <span>{{row.fecha_ingreso | date: 'dd/MM/yyyy'}}</span>
                        </td>
                        <td style="max-width: 110px;min-width: 110px;width: 110px;">
                            <span>{{row.fecha_termino | date: 'dd/MM/yyyy'}}</span>
                        </td>
                        <td style="max-width: 130px;min-width: 130px;width: 130px;" *ngIf="!mini" class="text-right">
                            <span>{{row.total_venta_format}}</span>
                        </td>
                        <td style="max-width: 140px;min-width: 140px;width: 140px;" *ngIf="!mini">
                            <span>{{row.estado.nombre_estado}}</span>
                        </td>
                        <td style="min-width: 200px;" *ngIf="showCliente">
                            <span class="btn btn-link p-0 text-dark"
                                (click)="goDetalleCliente(row.id_cliente)">{{row.cliente.nombre_completo}}</span>
                        </td>
                        <td style="max-width: 120px;min-width: 120px;width: 120px;" *ngIf="!mini" class="text-center">
                            <app-popover [classIcon]="'fas fa-tshirt ml-1'" [colorIcon]="'text-primary'"
                                *ngIf="row.productos" [message]="row.productos"></app-popover>
                            <app-popover [classIcon]="'fas fa-comment-dots ml-1'" [colorIcon]="'text-orange'"
                                [message]="row.observacion != '' ? row.observacion : 'S/C'"></app-popover>
                            <app-popover
                                [classIcon]="row.tiene_despacho > 0 ? 'fas fa-shipping-fast ml-1' : 'fas fa-store-alt ml-1'"
                                [colorIcon]="'text-lightblue'"
                                [message]="row.tiene_despacho > 0 ? '<b>DESPACHO</b>' : '<b>LOCAL</b>'"></app-popover>
                            <app-popover [classIcon]="'fas fa-info-circle ml-1'" [colorIcon]="'text-warning'"
                                *ngIf="row.fecha_termino == nextDay && row.id_estado != 5"
                                [message]="'<em>Entrega para</em> <b>MAÑANA</b>'"></app-popover>
                            <app-popover [classIcon]="'fas fa-info-circle ml-1'" [colorIcon]="'text-danger'"
                                *ngIf="row.fecha_termino == nowDay && row.id_estado != 5"
                                [message]="'<em>Entrega para</em> <b>HOY</b>'"></app-popover>
                            <app-popover [classIcon]="'fas fa-calendar-check ml-1'" [colorIcon]="'text-success'"
                                *ngIf="row.fecha_entrega_efectiva != null && row.id_estado == 5"
                                [message]="'<em>Entrega efectiva</em> <b>' + this.FechaFunc.DateTimeFormated(row.fecha_entrega_efectiva) + '</b>'"></app-popover>
                        </td>
                        <td style="max-width: 120px;min-width: 120px;width: 120px;">
                            <div class="btn-group">
                                <app-modal-metodo-pago *ngIf="onlyMedioPago" cssClass="first-element btn-sm"
                                    [onlyIcon]="true"
                                    (updateData)="updateMetodoPago($event, row.id_pedido,row.id_cliente)"></app-modal-metodo-pago>
                                <app-modal-cambia-estado cssClass="first-element btn-sm" [idPedido]="row.id_pedido"
                                    [estadoOld]="row.id_estado" [estadoOldText]="row.estado.nombre_estado"
                                    [estadoNew]="row.estado.next_estado" [estados]="estados" *ngIf="!onlyMedioPago"
                                    (updateData)="updateRows()"></app-modal-cambia-estado>
                                <!-- <app-ticket [cssClass]="mini ? 'last-element btn-sm' : 'middle-element btn-sm'"
                                    [idPedido]="row.id_pedido" [showButton]="true" *ngIf="!onlyMedioPago"></app-ticket> -->
                                <button type="button" class="btn btn-outline-primary" title="Ver Ticket" [ngClass]="mini ? 'last-element btn-sm' : 'middle-element btn-sm'"
                                    (click)="ticketGlobal.open(row.id_pedido)" *ngIf="!onlyMedioPago">
                                    <i class='fas fa-receipt'></i>
                                </button>
                                <button type="button" class="btn btn-outline-info btn-sm last-element" *ngIf="!mini"
                                    (click)="EditaPedido(row.id_pedido)">
                                    <app-popover [classIcon]="'fas fa-edit'" [message]="'Ver pedido'"></app-popover>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <app-footer-pagination *ngIf="rows && showFooter" [totalItems]="rows.length" [itemsPerPage]="itemsPerPage"
        [page]="page" (onPageChanged)="pageChanged($event)"></app-footer-pagination>
</div>
<app-ticket-global #ticketGlobal></app-ticket-global>